import React, { useState, useEffect } from 'react'
import { AttentionBox } from 'monday-ui-react-core';

export default function PermissionAttentionBox({ subBoards, setHasPermissions }) {

    const permissionRequiredBoards = subBoards?.filter(board => board.permissions !== "everyone" && board.isOwner === false);

    useEffect(() => {
        setHasPermissions && setHasPermissions(!permissionRequiredBoards?.length)
    }, [!!permissionRequiredBoards?.length])


    return (
        <>
            {!!permissionRequiredBoards?.length && <AttentionBox
                className='permission-attention-box'
                title="Permission Required"
                text={"The following boards do not have the necessary permissions: " + permissionRequiredBoards.map(board => board.label).join(',')}
                // text="You do not have the necessary permissions to establish a connection. Please check your access rights or contact your administrator for assistance."
                type={AttentionBox.types.DANGER}
            />
            }
        </>
    )
}